import { useQuery } from '@tanstack/react-query';
import { fetchLojaFisicaRecomendacoes } from '../../services/api';
import Loading from '../Loading/Loading';
import styles from './RecomendacoesInteligentes.module.css';

const RecomendacoesInteligentes = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['loja-fisica-recomendacoes'],
    queryFn: fetchLojaFisicaRecomendacoes,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <div className={styles.error}>Erro ao carregar recomendações: {error?.message}</div>;
  }

  // Extrair array de recomendações (pode vir como data.data ou data direto)
  const recomendacoes = Array.isArray(data) ? data : (data?.data || []);

  if (!recomendacoes || recomendacoes.length === 0) {
    return null; // Não renderiza nada se não houver recomendações
  }

  const getIconePorTipo = (tipo) => {
    switch (tipo) {
      case 'urgente':
      case 'critico':
        return '🚨';
      case 'alerta':
        return '⚠️';
      case 'atencao':
        return '📉';
      case 'oportunidade':
        return '📈';
      case 'sazonalidade':
        return '📅';
      default:
        return '💡';
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.titulo}>Recomendações Inteligentes</h2>
      <div className={styles.grid}>
        {recomendacoes.map((rec, index) => (
          <div key={index} className={`${styles.card} ${styles[rec.tipo]}`}>
            <div className={styles.cardHeader}>
              <span className={styles.icone}>{getIconePorTipo(rec.tipo)}</span>
              <h3 className={styles.cardTitulo}>{rec.titulo}</h3>
            </div>
            <p className={styles.mensagem}>{rec.mensagem}</p>
            <div className={styles.produtoInfo}>
              <strong>Produto:</strong> {rec.descricao} ({rec.codigoInterno})
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecomendacoesInteligentes;